// Step 16: every web address on the grant-database page is a real link.
// Opens in a new tab; long addresses wrap instead of breaking the layout.
const URL_PATTERN = /(https?:\/\/[^\s]+|www\.[^\s]+\.[^\s]+)/gi;

export default function Linkify({ text }) {
  if (text == null || text === '') return null;
  const value = String(text);
  const pieces = value.split(URL_PATTERN);
  return pieces.map((piece, i) => {
    if (i % 2 === 1) {
      const href = piece.startsWith('http') ? piece : `https://${piece}`;
      return (
        <a
          key={i}
          href={href}
          target="_blank"
          rel="noopener noreferrer"
          style={{ color: '#69AAFF', wordBreak: 'break-all' }}
        >
          {piece}
        </a>
      );
    }
    return piece;
  });
}
